import React from 'react';
import {
  FormControlLabel,
  Checkbox,
  Box,
  Typography
} from '@mui/material';

interface EmailPreferencesCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const EmailPreferencesCheckbox: React.FC<EmailPreferencesCheckboxProps> = ({ checked, onChange }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            color="primary"
            defaultChecked
          />
        }
        label={
          <Typography variant="body2">
            I would like to receive relevant email updates and resources from A Wise Friend
          </Typography>
        }
      />
    </Box>
  );
};